import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


import { CardEventComponent } from './card-event.component';

@NgModule({
  declarations: [CardEventComponent],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule
  ],
  exports: [CardEventComponent]
})
export class CardEventModule { }
